/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Amarantos API
 * REST API for the Amarantos construction and infrastructure management platform. Supports both the Panel (web) and App (mobile) clients.
 *
 * OpenAPI spec version: 1.0.0
 */

export type NodeType = typeof NodeType[keyof typeof NodeType];


export const NodeType = {
  manhole: 'manhole',
  soakaway: 'soakaway',
  pump_station: 'pump_station',
  tank: 'tank',
  separator: 'separator',
  tie_in: 'tie_in',
  inlet: 'inlet',
} as const;
